import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import GddDialog from "../../components/gdd-dialog/GddDialog";
import GddDialogTitle from "../../components/gdd-dialog/GddDialogTitle";
import GddPasswordIcon from "../../icons/profile/GddPasswordIcon";
import GddControls from "../../components/gdd-controls/GddControls";

function PasswordDetails(props) {
    const {
        open,
        setOpen,
        addOrEdit,
        values,
        setValues,
        setErrors,
        errors,
        handleInputChange,
        resetForm,
        validate,
        editMode,
        onKeyDown,
        disabled
    } = props;

    const iconType = <GddPasswordIcon iconSize="medium" />;
    const dlgTitle = (
        <GddDialogTitle title="Change Password" titleIcon={iconType} />
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            addOrEdit(values, editMode);
        }
    };

    return (
        <div>
            <GddDialog
                title={dlgTitle}
                open={open}
                setOpen={setOpen}
                onKeyDown={onKeyDown}
                handleSubmit={handleSubmit}
                resetForm={resetForm}
                disabled={disabled}
            >
                <Grid
                    container
                    rowSpacing={2}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                    <Grid item xs={12}>
                        <GddControls.GddTextField
                            fullWidth={true}
                            type="password"
                            name="currentPassword"
                            variant="outlined"
                            label="Current Password"
                            required={true}
                            value={values.currentPassword}
                            onChange={handleInputChange}
                            error={errors.currentPassword}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <GddControls.GddTextField
                            fullWidth={true}
                            type="password"
                            name="newPassword"
                            variant="outlined"
                            label="New Password"
                            required={true}
                            value={values.newPassword}
                            onChange={handleInputChange}
                            error={errors.newPassword}
                            disabled={disabled}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <GddControls.GddTextField
                            fullWidth={true}
                            type="password"
                            name="confirmNewPassword"
                            variant="outlined"
                            label="Confirm Password"
                            required={true}
                            value={values.confirmNewPassword}
                            onChange={handleInputChange}
                            error={errors.confirmNewPassword}
                            disabled={disabled}
                        />
                    </Grid>
                </Grid>
            </GddDialog>
        </div>
    );
}

export default PasswordDetails;
